// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zpHJ","label":"styles_label__1nWtn"};